/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PlanOfCareDiagnosesViewModel } from './PlanOfCareDiagnosesViewModel'; 

export function getDiagnosesBySignatureIdOptions(planOfCareSignatureId: string, onSuccess?: (result?: PlanOfCareDiagnosesViewModel) => void) {
	return queryOptions({
		queryKey: ['diagnoses-by-signature-id', planOfCareSignatureId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/diagnoses/queries/getdiagnosesbysignatureid/' + planOfCareSignatureId;
			const resp = await axios.get<PlanOfCareDiagnosesViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(planOfCareSignatureId)
	});
}